"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserAllowanceSchema = void 0;
const zod_1 = require("zod");
const Amount_1 = require("./Amount");
exports.UserAllowanceSchema = zod_1.z.object({
    owner: zod_1.z.string({ required_error: 'owner address is required' }),
    spender: zod_1.z.string({ required_error: 'spender address is required' }),
    tokenID: zod_1.z.string({ required_error: 'tokenID is required' }),
    amount: Amount_1.TokenAmountSchema,
});
